export default "/images/6b721c7e95cce94bda106f61a9801448.avif";